module.exports = __webpack_public_path__ + "img/komatsu_thumbnail.3909fdc8.png";